import { useContext } from 'react'
import { PreferencesContext } from '../../context/Preferences'

export default function GridListViewToggle() {
	const { productView, setView } = useContext(PreferencesContext)
	return (
		<div className="hidden gap-3 lg:flex">
			<button onClick={() => setView('grid')}>
				<svg
					data-tip="Toggle grid view"
					xmlns="http://www.w3.org/2000/svg"
					className={`h-6 w-6 ${productView === 'grid' ? '' : 'text-slate-300'}`}
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
					/>
				</svg>
			</button>
			<button onClick={() => setView('list')}>
				<svg
					data-tip="Toggle list view"
					xmlns="http://www.w3.org/2000/svg"
					className={`h-6 w-6 ${productView === 'list' ? '' : 'text-slate-300'}`}
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M4 6h16M4 10h16M4 14h16M4 18h16"
					/>
				</svg>
			</button>
		</div>
	)
}
